import React, { Fragment, useCallback } from 'react';
import { Box } from '@qga/roo-ui/components';
import { useDispatch } from 'react-redux';
import PriceFilter from 'components/Filters/Search/PriceFilter';
import StarRatingFilter from 'components/Filters/Search/RatingFilter/StarRatingFilter';
import TripadvisorRatingFilter from 'components/Filters/Search/RatingFilter/TripadvisorRatingFilter';
import PropertyTypeFilter from 'components/Filters/Search/PropertyTypeFilter';
import FacilityFilter from 'components/Filters/Search/FacilityFilter';
import SubRegionFilter from 'components/Filters/Search/SubRegionFilter';
import PaymentPolicyFilter from 'components/Filters/Search/PaymentPolicyFilter';
import SidebarItem from 'components/ListSearchPage/Sidebar/SidebarItem';
import ClearFilters from 'components/Filters/Search/ClearFilters';
import { updateQuery } from 'store/search/searchActions';

const Filters = () => {
  const dispatch = useDispatch();

  const onUpdateQuery = useCallback(
    (query) => {
      dispatch(updateQuery(query));
    },
    [dispatch],
  );

  return (
    <Fragment>
      <SidebarItem>
        <Box mb={[0, 0, 4]}>
          <ClearFilters />
        </Box>
      </SidebarItem>
      <SidebarItem>
        <Box mb={4}>
          <PriceFilter onChange={onUpdateQuery} />
        </Box>
      </SidebarItem>
      <SidebarItem>
        <PaymentPolicyFilter onChange={onUpdateQuery} />
      </SidebarItem>
      <SidebarItem>
        <StarRatingFilter onChange={onUpdateQuery} />
      </SidebarItem>
      <SidebarItem>
        <TripadvisorRatingFilter onChange={onUpdateQuery} />
      </SidebarItem>
      <SidebarItem>
        <PropertyTypeFilter onChange={onUpdateQuery} />
      </SidebarItem>
      <SidebarItem>
        <FacilityFilter onChange={onUpdateQuery} />
      </SidebarItem>
      <SidebarItem>
        <SubRegionFilter onChange={onUpdateQuery} />
      </SidebarItem>
    </Fragment>
  );
};

export default Filters;
